import HttpRequest from "../request";
import type { uploadFileInfo, translateFileInfo, md5FileInfo, CancelEstimateResp, CancelConfirmReq} from "./types";
import { TranslateApi, TermApi, AITranslateApi, TranslatePageApi} from "../api";
import type { Response } from "../request";
import eventBus from 'vue3-eventbus'

export default {
    getUploadFile(params: {data: FormData, key: number}): Promise<Response<uploadFileInfo>> {
        return HttpRequest.post(TranslateApi.getTranslateResult, params, {uploadFlag: true, onProgress: (progress) => {
            console.log("progress====", progress)
            eventBus.emit("onUploadProgress", {key: params.key, progress: progress})
        }})
    },
    getRequestOperateRecordId(params: {thisId: string}): Promise<Response<translateFileInfo>> {
        return HttpRequest.get(TranslateApi.getOperateRecordId, params)
    },

    getRequestCheckFileMD5(params: {fileMd5Strings: string}): Promise<Response<md5FileInfo>> {
        return HttpRequest.get(TranslateApi.getRequestCheckFileMD5, params)
    },

    getRequestTranslate(params: any): Promise<Response<any>> {
        return HttpRequest.post(TranslateApi.getTranslate, params)
    },

    getRequestTranslateCheckStatus(params: any): Promise<Response<any>> {
        return HttpRequest.get(TranslateApi.getTranslateCheckStatus, params)
    },
    // 取消翻译：实时估算当前阶段与应扣字符
    getRequestCancelTranslateEstimate(params: {operateRecordId: number}): Promise<Response<CancelEstimateResp>> {
        return HttpRequest.get(TranslateApi.getCancelTranslateEstimateApi, params)
    },
    // 取消翻译：按已确认的阶段/字符数提交取消；code 20045 表示阶段已变化需二次确认
    getRequestCancelTranslateConfirm(params: CancelConfirmReq): Promise<Response<CancelEstimateResp>> {
        return HttpRequest.post(TranslateApi.postCancelTranslateConfirmApi, params)
    },
    // 获取引擎
    getRequestEngines(): Promise<Response<any[]>> {
        return HttpRequest.get(TranslateApi.getEngines, null)
    },
    // 术语库相关
    getRequestUserSearchTermlist(params: any): Promise<Response<any>> {
        return HttpRequest.post(TermApi.getUserSearchTermlist, params)
    },
    getRequestCreateTerm(params: any): Promise<Response<any>> {
        return HttpRequest.post(TermApi.getCreateTerm, params)
    },
    getRequestUserTermlist(params: any): Promise<Response<any>> {
        return HttpRequest.get(TermApi.getUserTermlist, params)
    },
    getRequestDeleteTerm(params: any): Promise<Response<any>> {
        return HttpRequest.post(TermApi.getDeleteTerm, params)
    },
    getRequestEditTerm(params: any): Promise<Response<any>> {
        return HttpRequest.post(TermApi.getEditTerm, params)
    },
    getRequestTermentrylist(params: any): Promise<Response<any>> {
        return HttpRequest.get(TermApi.getTermentrylist, params)
    },
    getRequestAddTermentry(params: any): Promise<Response<any>> {
        return HttpRequest.post(TermApi.getAddTermentry, params)
    },
    getRequestDeleteTermentry(params: any): Promise<Response<any>> {
        return HttpRequest.post(TermApi.getDeleteTermentry, params)
    },
    getRequestEditTermentry(params: any): Promise<Response<any>> {
        return HttpRequest.post(TermApi.getEditTermentry, params)
    },
    getRequestTermImportentry(params: any): Promise<Response<any>> {
        return HttpRequest.post(TermApi.getTermImportentry, params)
    },
    getRequestTermImportterm(params: any): Promise<Response<any>> {
        return HttpRequest.post(TermApi.getTermImportterm, params)
    },
    getRequestCheckTermName(params: any): Promise<Response<any>> {
        return HttpRequest.get(TermApi.getCheckTermName, params)
    },
    getRequestCheckTermKeyName(params: any): Promise<Response<any>> {
        return HttpRequest.get(TermApi.getCheckTermKeyName, params)
    },
    getRequestExportExcelTerm(params: any): Promise<Response<any>> {
        return HttpRequest.get(TermApi.getExportExcelTerm, params)
    },
    getRequestArtInfos(params: any): Promise<Response<any>> {
        return HttpRequest.get(TermApi.getArtInfos, params)
    },
    getRequestPresetTermList(): Promise<Response<any>> {
        return HttpRequest.get(TermApi.getPresetTermList, null)
    },
    getRequestLastTranslateConfig(params: any): Promise<Response<any>> {
        return HttpRequest.get(TranslateApi.getLastTranslateConfigApi, params)
    },


    //ai 相关的
    getRequestAITranslateSendApi(params: any): Promise<Response<any>> {
        return HttpRequest.post(AITranslateApi.getAITranslateSendApi, params)
    },
    getRequestAITranslateDeleteHistoryApi(params: any): Promise<Response<any>> {
        return HttpRequest.post(AITranslateApi.getAITranslateDeleteHistoryApi, params)
    },
    getRequestAITranslateListHistoryApi(params: any): Promise<Response<any>> {
        return HttpRequest.get(AITranslateApi.getAITranslateListHistoryApi, params)
    },
    getRequestAiChatDownloadState(params: any): Promise<Response<any>> {
        return HttpRequest.get(AITranslateApi.getAiChatDownloadState, params)
    },
    getRequestAiChatDownloadFiles(params: any): Promise<Response<any>> {
        return HttpRequest.post(AITranslateApi.getAiChatDownloadFiles, params)
    },


    
    // ai 校对相关的
    getRequestAiProofreadingApi(params: any): Promise<Response<any>> {
        return HttpRequest.post(AITranslateApi.getAiProofreadingApi, params)
    },
    getRequestAiProofreadingCheckStatus(params: any): Promise<Response<any>> {
        return HttpRequest.get(AITranslateApi.getAiProofreadingCheckStatus, params)
    },
    getRequestCacheAiProofreadingCheck(params: any): Promise<Response<any>> {
        return HttpRequest.get(AITranslateApi.getCacheAiProofreadingCheck, params)
    },
    async requestGetAwsUploadFileUrl(params: any): Promise<Response<any>> {
        return await HttpRequest.get(TranslatePageApi.getAwsUploadFileUrl, params)
    },
    async getRequestAiProofreadingWritePdfApi(params: any): Promise<Response<any>> {
        return await HttpRequest.post(AITranslateApi.getAiProofreadingWritePdfApi, params)
    },
    getRequestAiProofreadingWritePdfStatus(params: any): Promise<Response<any>> {
        return HttpRequest.get(AITranslateApi.getAiProofreadingWritePdfStatus, params)
    },
    getRequestAiProofreadingGetPageContent(params: any): Promise<Response<any>> {
        return HttpRequest.post(AITranslateApi.getAiProofreadingGetPageContent, params)
    },
}


// 文件上传函数
export async function uploadJsonData(jsonData: any, url: string, fileName: string): Promise<any> {
    const blob = new Blob([JSON.stringify(jsonData)], { type: 'application/json' });
    const formData = new FormData();
    formData.append('file', blob, fileName);

    try {
        const response = await fetch(url, {
        method: 'put',
        body: jsonData,
        });
        if(response.status == 200 ) return true;

    } catch (error) {
        console.error('Error uploading JSON data:', error);
        return false;
    }
}
